<template>
  <div>

    <z-centralized-toolbar>  

      <v-btn id="btn-adicionar" depressed rounded color="primary" @click="adicionar">
        <v-icon left>{{ $icon.USUARIOS }}</v-icon>Adicionar
      </v-btn>

      <v-btn icon id="btn-atualizar" @click="listar" :loading="$store.state.loading">
        <v-icon>mdi-refresh</v-icon>
        <v-tooltip bottom activator="#btn-atualizar">
          Atualizar
        </v-tooltip>
      </v-btn>

      <!-- <v-spacer></v-spacer> -->

      <z-text-field-search 
        v-model="search" 
        select 
        class="ml-5" 
        @keydown.enter="listar" 
        @click:clear="limparBusca"
      ></z-text-field-search>

      <template #actions>
        <v-btn depressed rounded id="btn-adicionar" color="primary" @click="$router.push({name: 'UsuariosPermissoes'})">
          <v-icon left>{{ $icon.PERMISSOES }}</v-icon>Permissões
        </v-btn>
      </template>
    </z-centralized-toolbar>

    <v-divider></v-divider>

    <z-container>
      <h3 class="text-body-1 mb-3">{{$store.state.titulo_tela}}</h3>

      <v-card>
        <v-data-table
          mobile-breakpoint="0" 
          :headers="headers" 
          :items="usuarios" 
          item-key="id" 
          :loading="false" 
          :search="search"
        >
          <template v-slot:item="{ item: usuario }">
            <tr>
              <td>{{ usuario.id }}</td>
              <td>{{ usuario.name }}</td>
              <td>{{ usuario.email }}</td>
              <td>
                <v-chip small color="blue lighten-3">{{ usuario.perfil.descricao }}</v-chip>
              </td>
              <td class="text-center">
                <v-chip v-if="usuario.ativo == 1" small color="green lighten-3">Ativo</v-chip>
                <v-chip v-else small color="red lighten-3">Inativo</v-chip>
              </td>
              <td class="text-center">{{ usuario.last_login_at | dataHoraBR }}</td>
              <td class="text-center">
                <v-btn icon @click="editar(usuario)" class="ma-0">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="perguntarExcluir(usuario)" class="ma-0" v-if="usuario.name != 'Administrador'">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn small depressed color="primary" v-if="$auth.can('impersonate') && usuario.name != 'Administrador'" @click="$auth.impersonate(usuario.id)">
                  Impersonate
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo-sim-nao ref="dialogoExcluir" titulo="Remover usuário?" botaoSim="Remover" botaoNao="Cancelar" :loading="excluindo">
      O usuaário será removido do sistema.
    </z-dialogo-sim-nao>

    <dialogo-usuarios-form ref="usuarioForm"></dialogo-usuarios-form>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import DialogoUsuariosForm from './DialogoUsuariosForm.vue';

export default {
  name: 'UsuariosLista',

  components: { DialogoUsuariosForm },

  data() {
    return {
      // globals,
      headers: [
        { text: "Código", value: "id", width: "100px" },
        { text: "Nome", value: "name" },
        { text: "Login", value: "email" },
        { text: "Perfil", value: "perfil.descricao" },
        { text: "Situação", value: "ativo", align: "center" },
        { text: "Último Acesso", value: "last_login_at", align: "center" },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false }
      ],
      search: "",
      pagination: {},
      excluindo: false,
      usuario: {},
      listagem: 'Recentes'
    };
  },

  created() {
    this.setTitulo('Usuários');
    this.listar();
  },

  methods: {
    ...mapMutations(['setTitulo']),
    ...mapActions('usuarios', ['listar', 'excluir', 'abrir']),

    async editar(usuario) {
      await this.abrir(usuario.id);
      // this.$router.push({ name: "UsuariosEditar", params: { id: usuario.id } });
      this.$refs.usuarioForm.abrir();
    },

    perguntarExcluir(usuario) {
      this.$refs.dialogoExcluir.abrir()
        .then(async response => {

          if (response == true) {
            await this.confirmarExcluir(usuario);
            // this.$refs.dialogoExcluir.fechar();
          }
        })
    },

    async confirmarExcluir(usuario) {
      try {
        this.excluindo = true;
        await this.excluir(usuario.id);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
        this.$eventbus.notificar('Usuário excluído com sucesso!');
      }
    },

    limparBusca() {
      this.busca = null;
      // this.$store.commit('bancos/SET_PAGE', 1);
      this.listar();
    },

    adicionar() {
      this.$store.commit('usuarios/UNSET_USUARIO');
      this.$refs.usuarioForm.abrir();
      // this.$router.push({ name: "UsuariosAdicionar" });
    },
  },

  computed: {
    ...mapState(['loading', 'titulo_tela']),
    ...mapState("usuarios", ["usuarios"])
  }
};
</script>

<style scoped>
</style>
